/* ChinaTourly number counter — IntersectionObserver count-up (replaces fragile jQuery inview) */
function numberCounter() {
  function splitDisplay(el) {
    var raw = el.getAttribute('data-display') || el.getAttribute('data-value') || el.textContent || '';
    var display = String(raw).trim();
    var match = display.match(/^(-?\d[\d,]*(?:\.\d+)?)(.*)$/);
    var num = match ? parseFloat(match[1].replace(/,/g, '')) : NaN;
    return { display: display, number: num, suffix: match ? match[2] : '', isNumeric: !!match && !isNaN(num) };
  }
  function fmt(n) {
    return Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function suffixEl(el) {
    var nx = el.nextElementSibling;
    return (nx && nx.classList && nx.classList.contains('number-counter-suffix')) ? nx : null;
  }
  function run(el) {
    var parts = splitDisplay(el);
    var sfx = suffixEl(el);
    if (!parts.isNumeric) {                 // 非数字(如 24h 全文) → 原样显示,不动
      el.textContent = parts.display;
      if (sfx && /nan/i.test(sfx.textContent)) sfx.textContent = '';
      return;
    }
    if (sfx) sfx.textContent = parts.suffix;
    var startTs = null, duration = 1600;
    function step(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min((ts - startTs) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);   // easeOutCubic
      el.textContent = fmt(parts.number * eased);
      if (p < 1) { requestAnimationFrame(step); }
      else {
        el.textContent = fmt(parts.number);
        if (sfx) sfx.textContent = parts.suffix;
      }
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }
  var sections = document.querySelectorAll('.number-counter');
  Array.prototype.forEach.call(sections, function (section) {
    var values = section.querySelectorAll('.number-counter-value');
    if (!values.length) return;
    var fired = false;
    function fire() {
      if (fired) return; fired = true;
      Array.prototype.forEach.call(values, run);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { fire(); io.disconnect(); break; }
        }
      }, { threshold: 0.25 });
      io.observe(section);
    } else {
      fire();
    }
  });
}
if (document.readyState !== 'loading') { numberCounter(); }
else { document.addEventListener('DOMContentLoaded', numberCounter); }
